import {
  EVENT_SIDEBAR_TOGGLE,
  EVENT_SIDEBAR_CLOSED,
} from "@slhuinav/base/events";

const BODY_ELEMENT_HIDDEN_OVERFLOW: string = "hidden";
const BODY_ELEMENT_AUTO_OVERFLOW: string = "auto";
const BODY_ELEMENT_HIDDEN_HEIGHT: string = "0px";
const BODY_ELEMENT_AUTO_HEIGHT: string = "auto";
const MOBILE_BREAK_POINT: number = 560;
const RESIZE_TRESHOLD: number = 500;
const CLICK_EVENT = "click";
const KEYDOWN_EVENT = "keydown";

export {
  EVENT_SIDEBAR_TOGGLE,
  EVENT_SIDEBAR_CLOSED,
  BODY_ELEMENT_AUTO_OVERFLOW,
  BODY_ELEMENT_HIDDEN_OVERFLOW,
  BODY_ELEMENT_AUTO_HEIGHT,
  BODY_ELEMENT_HIDDEN_HEIGHT,
  MOBILE_BREAK_POINT,
  RESIZE_TRESHOLD,
  CLICK_EVENT,
  KEYDOWN_EVENT,
};
